import Axios from "axios";
import {
    SET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST, 
    UNSET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST
} from "@/store/mutation-types";
import {
    getLeaveEmployeeWiseSummaryReport,
} from "@/store/api";

const state = {
    getLeaveEmployeeWiseSummaryReport: [],
};

const getters = {
    getLeaveEmployeeWiseSummaryReport(state) {
        return state.getLeaveEmployeeWiseSummaryReport;
    },
};

const mutations = {
    [SET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST](state, data) {
        state.getLeaveEmployeeWiseSummaryReport = data;
    },
    [UNSET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST](state) {
        state.getLeaveEmployeeWiseSummaryReport = [];
    },
};

const actions = {

    getLeaveEmployeeWiseSummaryReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getLeaveEmployeeWiseSummaryReport}`, { params: data })
                .then((response) => {
                    commit(SET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_LEAVE_EMPLOYEE_WISE_SUMMARY_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
  state,
  getters,
  actions,
  mutations,
};